import { render } from "./GameMapView.vue?vue&type=template&id=70dde039&ts=true"
import script from "./GameMapView.vue?vue&type=script&lang=ts"
export * from "./GameMapView.vue?vue&type=script&lang=ts"

import "./GameMapView.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__